var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  box-sizing: border-box;\n  position: relative;\n  height: 100%;\n\n  @media (min-width: 600px) {\n    top: auto;\n    left: auto;\n    margin-bottom: ', ';\n    height: ', ';\n    width: ', ';\n    box-shadow: 0 0 20px 0 rgba(32, 24, 73, 0.39);\n    border-radius: 6px;\n  }\n'], ['\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  box-sizing: border-box;\n  position: relative;\n  height: 100%;\n\n  @media (min-width: 600px) {\n    top: auto;\n    left: auto;\n    margin-bottom: ', ';\n    height: ', ';\n    width: ', ';\n    box-shadow: 0 0 20px 0 rgba(32, 24, 73, 0.39);\n    border-radius: 6px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';

var Wrapper = function Wrapper(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return React.createElement(
    'div',
    { className: className },
    children
  );
};

var StyledWrapper = styled(Wrapper)(_templateObject, function (props) {
  var padInt = parseInt(props.theme.padding, 10);
  return padInt + 32 + 'px';
}, function (props) {
  return props.theme.height;
}, function (props) {
  return props.theme.width;
});

export default StyledWrapper;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/wrapper.js
// module id = 206
// module chunks = 1